import { Component, Inject, OnInit } from '@angular/core';
import { BrowserHelper } from './shared/helpers/browser.helper';
import { EnvironmentService } from './core/services/environment.service';
import { CrmFeatures } from './shared/enumerations/crm.enumeration';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IdleSessionDebugLevel } from '@ucdhs-ais/ais-ng-library-ng11-png11';
import { APP_BASE_HREF } from '@angular/common';
import { PrimeNgAccessibilityHelper } from './shared/helpers/primeng-accessibility.helper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'hsform-application-tracker';
  isSafari = BrowserHelper.isSafari();
  isIE = BrowserHelper.isIE();
  allowed = false;
  securityChecked = false;

  keepalives: (string | (() => Observable<any>))[] = [];
  debugLevels = IdleSessionDebugLevel;

  constructor(
    private router: Router,
    private envService: EnvironmentService,
    @Inject(APP_BASE_HREF) private baseHref: string,
  ) {
    this.keepalives.push(this.keepAliveCallback);

    const winUrl = window.location.href;
    if (!(winUrl.indexOf('formId') > 0)) {
      this.securityAppAccessCheck();
    }
  }

  ngOnInit() {
    const winUrl = window.location.href;
    if (winUrl.indexOf('formId') > 0) {
      const url = new URL(winUrl);
      const formId = url.searchParams.get('formId');
      const internal = url.searchParams.get('internal');
      const sid = url.searchParams.get('sid');
      const k = url.searchParams.get('k');
      this.router.navigate(['view-form'], {
        queryParams: {
          formId: formId,
          sid: sid,
          k: k,
          internal: internal === 'Yes' ? 'Yes' : 'No',
        },
      });
    }
    PrimeNgAccessibilityHelper.initGlobalPatch();
  }

  keepAliveCallback = (): Observable<any> => {
    console.log(`${new Date()} - MainComponent: keepAliveCallback() called`);
    return this.envService.getEnvironment();
  };

  debugCallback = (logText: string): void => {
    // console.log(`${new Date()} - !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!`);
    console.log(`${new Date()} - MainComponent: ${logText}`);
    // console.log(`${new Date()} - ****************************************************************************`);
    // console.log(`${new Date()} - MainComponent: authManager.isAuthenticatedOrAuthenticating() =${this.authManager.isAuthenticatedOrAuthenticating()}`);
    // console.log(`${new Date()} - MainComponent: authManager.isSessionFrozen()=${this.authManager.isSessionFrozen()}`);
    // console.log(`${new Date()} - MainComponent: authManager.wasAuthorizationPerformed()=${this.authManager.wasAuthorizationPerformed()}`);
    // console.log(`${new Date()} - MainComponent: multiplePrograms=${this.multiplePrograms}`);
    // console.log(`${new Date()} - MainComponent: authManager.hasFeature('SRECORDS_APP_ACCESS')=${this.authManager.hasFeature('SRECORDS_APP_ACCESS')}`);
    // console.log(`${new Date()} - MainComponent: authManager.isAuthenticated()=${this.authManager.isAuthenticated()}`);
    // console.log(`${new Date()} - ****************************************************************************`);
  };

  continueSession() {
    this.envService.getEnvironment().subscribe(
      (env) => {
        let url = `https://ssodev.ucdavis.edu/cas/login?service=`;

        if (env.server && env.server.startsWith('prod-')) {
          url = `https://cas.ucdavis.edu/cas/login?service=`;
        }

        url += `${window.location.protocol}//${window.location.host}${this.baseHref}`;

        window.location.href = url;
      },
      (err) => {
        console.error(err);
      },
    );

    // console.log(url);
    // this.authManagerWrapper.loginIfNotAlready();
  }

  securityAppAccessCheck() {
    this.allowed = false;
    this.envService.getUserFeatures().subscribe(
      (features) => {
        const feature = features.find(
          (feature) => feature === CrmFeatures.HSFORM_APP_ACCESS,
        );
        if (feature === CrmFeatures.HSFORM_APP_ACCESS) {
          this.allowed = true;
        }
      },
      (err) => {
        console.log(err);
      },
      () => {
        this.securityChecked = true;
      },
    );
  }
}
